import React, { useMemo, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Popover from 'src/Components/Common/Popover';
import { CREATE_INTERNAL_TICKET, CREATE_TICKET, ROUTES, START_CLAIM, } from 'src/Utils';
import { ButtonContainer, ButtonLabel, Chevron } from './styles';
import { ChevronDown } from 'src/assets/Images';
var TICKET_TYPE_OPTIONS = [
    { label: 'Cliente', value: 'external' },
    { label: 'Interno', value: 'internal' },
];
var CreateTicketButton = function (_a) {
    var buildingId = _a.buildingId, fixedType = _a.fixedType;
    var history = useHistory();
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var buttonRef = useRef(null);
    var data = useMemo(function () {
        return TICKET_TYPE_OPTIONS.map(function (o) { return ({
            label: o.label,
            value: o.value,
        }); });
    }, []);
    var closeMenu = function () { return setAnchorEl(null); };
    var handleSelect = function (item) {
        var params = new URLSearchParams({ type: String(item.value) });
        if (buildingId != null) {
            params.append('building_id', String(buildingId));
        }
        history.push(ROUTES.create_ticket + "?" + params.toString());
    };
    var buttonLabel = fixedType === 'external'
        ? START_CLAIM
        : fixedType === 'internal'
            ? CREATE_INTERNAL_TICKET
            : CREATE_TICKET;
    return (React.createElement(React.Fragment, null,
        React.createElement(ButtonContainer, { ref: buttonRef, onClick: function () {
                if (fixedType) {
                    handleSelect({ label: '', value: fixedType });
                }
                else {
                    setAnchorEl(buttonRef.current);
                }
            }, type: "button" },
            React.createElement(ButtonLabel, null, buttonLabel),
            !fixedType && (React.createElement(Chevron, null,
                React.createElement("img", { src: ChevronDown, alt: "chevron-down" })))),
        !fixedType && (React.createElement(Popover, { anchorRef: anchorEl, handleOutsideClick: closeMenu, data: data, setSelected: handleSelect, isFilter: false }))));
};
export default CreateTicketButton;
